import { useEffect, useRef, useState } from 'react';
import './GallerySection.css';
import Tools from '@/assets/images/home/GallerySection/imageTools.jpeg'
import Mascarilla from '@/assets/images/home/GallerySection/imageMascarilla.jpeg'
import Interior from '@/assets/images/home/GallerySection/imageStudio.jpeg'
import Machines from '@/assets/images/home/GallerySection/imageMachines.jpeg'
import Fade from '@/assets/images/home/GallerySection/imageFade.jpeg'
import Afeitado from '@/assets/images/home/GallerySection/imageAfeitado.jpeg'

const galleryImages = [
  {
    src: Tools,
    alt: 'Herramientas premium',
  },
  {
    src: Mascarilla,
    alt: 'Mascarilla de exfoliación',
  },
  {
    src: Interior,
    alt: 'Interior del estudio',
  },
  {
    src: Fade,
    alt: 'Fade',
  },
  {
    src: Machines,
    alt: 'Maquinas de última generación',
  },
  {
    src: Afeitado,
    alt: 'Afeitado clásico',
  },
];

export default function GallerySection() {
  const [visible, setVisible] = useState(false);
  const [paused, setPaused] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  const trackRef = useRef<HTMLDivElement>(null);
  const posRef = useRef(0);
  const rafRef = useRef<number>(0);
  const speed = 1.1; // px per frame

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const animate = () => {
      if (!paused) {
        posRef.current -= speed;
        const halfWidth = track.scrollWidth / 2;
        if (Math.abs(posRef.current) >= halfWidth) {
          posRef.current = 0;
        }
        track.style.transform = `translateX(${posRef.current}px)`;
      }
      rafRef.current = requestAnimationFrame(animate);
    };

    rafRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafRef.current);
  }, [paused]);

  // Duplicate images for seamless loop
  const doubled = [...galleryImages, ...galleryImages];

  return (
    <section
      ref={sectionRef}
      id="galeria"
      className={`gallery-section py-24 md:py-32 transition-all duration-700 ${
        visible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      {/* Header */}
      <div
        className={`text-center mb-14 px-4 transition-all duration-700 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        <p className="gallery-section-label mb-4">◆ Nuestro Trabajo ◆</p>
        <h2 className="gallery-section-title">Galería</h2>
        <div className="gallery-section-divider" />
      </div>

      {/* Marquee strip */}
      <div
        className="gallery-marquee-wrapper"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <div ref={trackRef} className="gallery-marquee-track">
          {doubled.map((img, idx) => (
            <div key={idx} className="gallery-marquee-item">
              <img
                src={img.src}
                alt={img.alt}
                draggable={false}
              />
              <div className="gallery-marquee-caption">
                <span>{img.alt}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Hint */}
      <p
        className={`gallery-hint transition-all duration-100 delay-100 ${
          visible ? 'opacity-100' : 'opacity-0'
        }`}
      >
        Pasa el cursor para pausar
      </p>
    </section>
  );
}
